import { Component } from "react";
import * as Sentry from "@sentry/browser";
import { isChunkLoadError, showRefreshNotice } from "../utils/lazyWithRetry";

// Catches chunk load failures that lazyWithRetry could not recover from
// (retries + auto-reloads exhausted). Any other error is rethrown untouched.
class ChunkErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    if (!isChunkLoadError(error)) return;
    Sentry.captureException(error, { tags: { chunk_load: "exhausted" } });
    if (!this.props.silent) showRefreshNotice();
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    if (!isChunkLoadError(error)) throw error;
    return null;
  }
}

export default ChunkErrorBoundary;
